'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaitlistFormContainer = exports.mapDispatchToProps = exports.mapStateToProps = exports.WaitlistForm = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _decorator = require('helpers/decorator');

var _forms = require('helpers/forms');

var _multitrack = require('helpers/multitrack');

var _verify = require('helpers/verify');

var _bound = require('redux/saga/entities/bound');

var _LeadGenForm = require('features/LeadGenForm/LeadGenForm');

var _WaitlistFormValidator = require('./WaitlistFormValidator');

var _location = require('./location.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  locationCta: {
    id: 'location-modal.waitlist-cta',
    defaultMessage: 'Keep me updated'
  }
});

var WaitlistForm = exports.WaitlistForm = function (_Component) {
  (0, _inherits3.default)(WaitlistForm, _Component);

  function WaitlistForm() {
    (0, _classCallCheck3.default)(this, WaitlistForm);
    return (0, _possibleConstructorReturn3.default)(this, (WaitlistForm.__proto__ || (0, _getPrototypeOf2.default)(WaitlistForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(WaitlistForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _multitrack.ga)('Geo_Detection_Modal', 'viewed_lead_gen', '', 0, { nonInteraction: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var intl = this.props.intl;


      return _react2.default.createElement(
        'div',
        { className: 'location-modal--waitlist-form' },
        _react2.default.createElement(
          'h2',
          { className: 'location-modal__title' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'location-modal.waitlist-header',
            defaultMessage: 'We\u2019re not there yet'
          })
        ),
        _react2.default.createElement(
          'p',
          { className: 'location-modal__subtitle' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'location-modal.waitlist-subtitle',
            defaultMessage: 'But we hope to be! Share your email and we\u2019ll let you know when we\u2019re available near you.'
          })
        ),
        _react2.default.createElement(_LeadGenForm.LeadGenForm, (0, _extends3.default)({}, this.props, {
          intl: intl,
          ctaCopy: intl.formatMessage(messages.locationCta),
          hideLocation: true,
          singleLineBreakpoint: 'none'
        }))
      );
    }
  }]);
  return WaitlistForm;
}(_react.Component);

WaitlistForm.propTypes = (0, _extends3.default)({}, _LeadGenForm.LeadGenForm.propTypes);

var formConfig = {
  form: 'locationModalWaitlist',
  validate: _WaitlistFormValidator.WaitlistFormValidator
};

var getError = (0, _forms.getFirstError)(formConfig.form);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    formError: getError(state) || _bound.waitlistRequest.error(state),
    wasCaptured: !(0, _verify.isEmpty)(_bound.waitlistRequest.data(state))
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  onWaitlistRequest: _location.joinWaitlist
};

var WaitlistFormContainer = exports.WaitlistFormContainer = (0, _decorator.decorateWith)(_reactIntl.injectIntl, (0, _reduxForm.reduxForm)(formConfig), (0, _decorator.withName)('WaitlistForm'), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(WaitlistForm);